import { http } from './config'

export default {
  getAllSetups: () => {
    return http.get('setups')
  },

  getFilteredSetups: (params) => {
    return http.get('setups', { params })
  },

  getSetupById: (setupId) => {
    return http.get('setups/' + setupId)
  },

  getAllBlindConferenceTypes: () => {
    return http.get('blind_conference_types')
  },

  createSetup: (setupParams) => {
    return http.post('setups', {
      blind_conference: setupParams.blind_conference,
      name: setupParams.locality.name,
      bar_code: setupParams.bar_code,
      sap_integration: setupParams.sap_integration,
      check_for_divergences: setupParams.check_for_divergences,
      locality_id: setupParams.locality.id,
      quantity_attempts: setupParams.quantity_attempts,
      ranking: setupParams.ranking,
      container_distribution: setupParams.container_distribution,
      locker_availability: setupParams.locker_availability,
      ia_palletization: setupParams.ia_palletization,
      ia_sort: setupParams.ia_sort,
      palletization_type_id: setupParams.palletizationType.id ? setupParams.palletizationType.id : null,
      sort_type_id: setupParams.sortType ? setupParams.sortType.id : null,
      palletizing_complexity_check: setupParams.palletizing_complexity_check,
      separation_by_client: setupParams.separation_by_client,
      minimal_cubage_by_client: setupParams.minimal_cubage_by_client,
      automatic_palletization: setupParams.automatic_palletization,
      blind_conference_type_id: setupParams.blindConferenceType ? setupParams.blindConferenceType.id : null,
    })
  },

  updateSetup: (setupParams) => {
    return http.put('setups/' + setupParams.setupId, {
      blind_conference: setupParams.blind_conference,
      name: setupParams.locality.name,
      bar_code: setupParams.bar_code,
      sap_integration: setupParams.sap_integration,
      check_for_divergences: setupParams.check_for_divergences,
      locality_id: setupParams.locality.id,
      quantity_attempts: setupParams.quantity_attempts,
      ranking: setupParams.ranking,
      container_distribution: setupParams.container_distribution,
      locker_availability: setupParams.locker_availability,
      ia_palletization: setupParams.ia_palletization,
      ia_sort: setupParams.ia_sort,
      palletization_type_id: setupParams.palletizationType ? setupParams.palletizationType.id : null,
      sort_type_id: setupParams.sortType ? setupParams.sortType.id : null,
      palletizing_complexity_check: setupParams.palletizing_complexity_check,
      separation_by_client: setupParams.separation_by_client,
      minimal_cubage_by_client: setupParams.minimal_cubage_by_client,
      automatic_palletization: setupParams.automatic_palletization,
      blind_conference_type_id: setupParams.blindConferenceType ? setupParams.blindConferenceType.id : null,
    })
  },

  deleteSetup: (setupId) => {
    return http.delete('setups/' + setupId)
  },

  exportQrcodePdf: (localityId, start_number, end_number) => {
    return http.get('setups/export_qrcode_pdf/?locality_id=' + localityId + '&start_number=' + start_number + '&end_number=' + end_number)
  },

}
